module.exports = __webpack_public_path__ + "img/list_alt-24px.c88f34f0.svg";